module.exports = __webpack_public_path__ + "static/media/close-icon-red.d41d5597.svg";